import { locale } from 'dayjs'

export const DanishDayLocale = {
  formats: {
    L: 'DD.MM.YYYY',
    LL: 'D. MMMM YYYY',
    LLL: 'D. MMMM YYYY HH:mm',
    LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
  },
  months:
    'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
      '_',
    ),
  monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
  name: 'da',
  ordinal: (n: number) => `${n}`,
  relativeTime: {
    M: 'en måned',
    MM: '%d måneder',
    d: 'en dag',
    dd: '%d dage',
    future: 'om %s',
    h: 'en time',
    hh: '%d timer',
    m: 'et minut',
    mm: '%d minutter',
    past: '%s siden',
    s: 'få sekunder',
    ss: '%d sekunder',
    y: 'et år',
    yy: '%d år',
  },
  weekStart: 1,
  weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
  weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
  weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
  yearStart: 4,
}

locale(DanishDayLocale, undefined, true)
